import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login-password",
  "use": "icon-login-password-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-login-password\"><g stroke=\"currentColor\"><path fill=\"transparent\" d=\"M4 5V4c0-1.657 1.567-3 3.5-3h0C9.433 1 11 2.343 11 4v1\" /><rect fill=\"transparent\" x=\"1.5\" y=\"5.5\" width=\"12\" height=\"8\" rx=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol